var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"header-class":_vm.header_class,"header-bg-variant":_vm.header_bg_variant,"header":_vm.header,"header-tag":_vm.header_tag}},[_c('b-collapse',{attrs:{"id":"card-body"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('b-card-body',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }